import { takeLatest } from "redux-saga/effects";

import { processCallbackAction } from "@/redux/helper";
import apiConfig from "@/constants/apiConfig";
import { transactionActionTypes } from "@/redux/actions";

const {GET_SMS_TRANSACTIONS, EXPORT_TRANSACTIONS} = transactionActionTypes;

const getSMSTransactions = (action) => {
    return processCallbackAction(apiConfig.transaction.getSMSTransaction, action);
}

const exportTransactions = (action) => {
    return processCallbackAction(apiConfig.transaction.exportExcel, action);
}

const transactionSagas = [
    takeLatest(GET_SMS_TRANSACTIONS, getSMSTransactions),
    takeLatest(EXPORT_TRANSACTIONS, exportTransactions),
]

export default transactionSagas;